import Header from 'components/Header';
import React, { useEffect, useState } from 'react';
import Datetime from 'react-datetime';
import PropTypes from 'prop-types';
import Input from 'components/Form/Input';
import Button from 'components/Button';
import './style.scss';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { newNextAction } from 'actions/navigation';
import moment from 'moment';
import Progress from 'components/Progress';
import ApplicationId from 'components/ApplicationId';
import Modal from 'components/Modal';
import { getOrConvertToPst } from 'utils/timezone';
import schema from './schema';
import Validator from '../../../components/Validator/index';
import infoIcon from '../../../assets/images/icon-info.svg';

const PickPaymentDate = (props) => {
  const { checkinData, validator: { setValues, values, errors, validate, onChangeHandler }, navigate, params, searchParams } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(false);
  const workflowType = get(params, 'workflowType');
  const key = searchParams.get('key');

  useEffect(() => {
    if (get(checkinData, ['data', 'data']) === undefined) {
      navigate(`${workflowType ? `/${workflowType}` : ''}/?key=${key}`);
    } else {
      setValues({
        ...values,
        firstPaymentDate: getOrConvertToPst().add(37, 'd'),
      });
    }
  }, []);

  const toggleModal = () => {
    setIsModal(!isModal);
  };

  const handleDateChange = (date) => {
    onChangeHandler('firstPaymentDate', date);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { dispatch } = props;
    const test = searchParams.get('test');

    if (schema && validate(schema).isValid) {
      setIsLoading(true);
      dispatch(newNextAction({
        key,
        workflowType: workflowType || 'text2apply',
        data: {
          test,
          FirstPaymentDate: moment(values.firstPaymentDate).format('MM-DD-YYYY'),
        },
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (response) => {
          const routeUrl = get(response, 'data.url');
          props.navigate(routeUrl);
          setIsLoading(false);
        },
        fail: (error) => {
          setIsLoading(false);
          console.log(error);
        },
      }));
    } else {
      setIsLoading(false);
    }
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      <ApplicationId id={get(checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      <div className="heading-div bg-white">
        <h2>PLEASE SELECT NEW PAYMENT DATE</h2>
        <div className="info-wrapper">
          <h4>
            The payment date you have previously selected
            {' '}
            {get(checkinData, 'data.data.firstPaymentDate') ? getOrConvertToPst(get(checkinData, 'data.data.firstPaymentDate')).format('L') : ''}
            {' '}
            is no longer available.
            <img
              src={infoIcon}
              alt="info icon"
              width={18}
              onClick={toggleModal}
            />
          </h4>
        </div>
        <div className="bg-light datePicker-wrapper">
          <h4>Choose First Payment Date</h4>
          <p>Select a payment date which matches your payroll date.</p>
          <Datetime
            name="firstPaymentDate"
            label="First Payment Date"
            className="dateWrapper"
            value={values.firstPaymentDate}
            defaultValue={Datetime.moment().add(37, 'd')}
            onChange={handleDateChange}
            closeOnSelect
            dateFormat="MM/DD/YYYY"
            displayTimeZone="America/Los_Angeles"
            timeFormat={false}
            isValidDate={(current) => (
              current.isAfter(Datetime.moment().add(36, 'd'))
              && current.isBefore(Datetime.moment().add(47, 'd'))
            )}
            placeHolder="MM/DD/YYYY"
            renderInput={(renderProps) => (
              <Input
                isMasked={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                isRequired
                openCalendar={() => { }}
                hasError={!!errors.firstPaymentDate}
                errorMessage={errors.firstPaymentDate}
                label="First Payment Date"
                placeHolder="MM/DD/YYYY"
                {...renderProps}
              />
            )}
          />
        </div>
        <div className="confirm-btn">
          <Button
            className="btn btn-primary"
            type="button"
            onClick={handleSubmit}
            isLoading={isLoading}
            title={!isLoading && 'CONFIRM'}
          />
        </div>
      </div>
      {isModal && (
      <Modal>
        <div className="card-header">
          <h5>Why do I have to change my payment date?</h5>
        </div>
        <div className="close" onClick={toggleModal} />
        <div className="card-content popoverContent">
          There must be at least
          {' '}
          {get(checkinData, 'data.data.days')}
          {' '}
          days between funding and the first payment date.
          <br />
          You will be able to adjust your first payment date by calling our servicing team after your loan has been funded. (needs to be rephrased)
        </div>
      </Modal>
      )}
      {
        isLoading && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

PickPaymentDate.propTypes = {
  validator: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,// eslint-disable-line
  nextAction: PropTypes.func.isRequired,
  workflow: PropTypes.object.isRequired,// eslint-disable-line
  dispatch: PropTypes.func.isRequired,
  checkinData: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default Validator(schema)(connect(mapStateToProps)(PickPaymentDate));
